// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import {
  getAuth,
  connectAuthEmulator,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";

import {
  getFirestore,
  doc,
  getDoc,
  connectFirestoreEmulator
} from "firebase/firestore";

import {
  getFunctions,
  connectFunctionsEmulator
} from "firebase/functions";

import { getStorage } from "firebase/storage";

// —————————————————————————————————————————————————————————————
// 1) Your web app's Firebase configuration from environment
// —————————————————————————————————————————————————————————————
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// —————————————————————————————————————————————————————————————
// 2) Initialize Firebase App + Analytics
// —————————————————————————————————————————————————————————————
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

// —————————————————————————————————————————————————————————————
// 3) Initialize Auth, Firestore & Functions
// —————————————————————————————————————————————————————————————
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const googleProvider = new GoogleAuthProvider();
export const storage = getStorage(app);

// Export email-link helpers
export {
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signInWithPopup
};

// Export Firestore helpers if you want to use them elsewhere
export {
  doc,
  getDoc
};

// —————————————————————————————————————————————————————————————
// 4) If running with emulator flag, connect to emulators
//    (REACT_APP_USE_FIREBASE_EMULATOR=true)
// —————————————————————————————————————————————————————————————
if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === "true") {
  // Auth Emulator (poort 9099)
  connectAuthEmulator(auth, "http://localhost:9099", {
    disableWarnings: true
  });

  // Firestore Emulator (poort 8080)
  connectFirestoreEmulator(db, "localhost", 8080);

  // Functions Emulator (poort 5001)
  connectFunctionsEmulator(functions, "localhost", 5001);
}
